import { useGraphQLQuery } from '@opengov/bnp-core';
import isEmpty from 'lodash/isEmpty';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { graphql } from '../../../../../gql-generated/hasura';
import { useToast } from '../../../Toast/context/useToast.context';
import { customReportsQueryKeys } from './customReportsQueryKeys';

const FetchSpreadsheetNamedRangesForExpandedRowQuery = graphql(`
  query GetSpreadsheetNamedRangesForExpandedRow($spreadsheetId: uuid!) {
    spreadsheetNamedRanges(where: { spreadsheetId: { _eq: $spreadsheetId } }) {
      ...CustomReportsTableExpandedRowStoryList_CustomReportFragment
    }
  }
`);

export function useFetchNamedRangesForExpandedRow({ spreadsheetId }: { spreadsheetId: string }) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: customReportsQueryKeys.namedRangesForTable(spreadsheetId),
    variables: { spreadsheetId: spreadsheetId },
    document: FetchSpreadsheetNamedRangesForExpandedRowQuery,
    url: HASURA_SERVICE_URL,
    options: {
      enabled: !isEmpty(spreadsheetId),
      select: (data) => data.spreadsheetNamedRanges,
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: 'Something went wrong',
          body: 'Unable to fetch named ranges',
          severity: 'error'
        });
      }
    }
  });
}
